"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const Minimize = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 12,
  height: 2,
  viewBox: "0 -4 12 2"
}, props), /*#__PURE__*/_react.default.createElement("title", null, "FB61C913-B728-4091-A0A8-4DE5F5085300"), /*#__PURE__*/_react.default.createElement("rect", {
  x: 24,
  y: 10.5,
  width: 12,
  height: 1.5,
  rx: 0.75,
  transform: "translate(-24 -10)",
  className: "fill"
}));

var _default = Minimize;
exports.default = _default;